import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionService } from '../services/session.service';

@Component({
  selector: 'app-dialog-start-video',
  templateUrl: './dialog-start-video.component.html',
  styleUrls: ['./dialog-start-video.component.scss']
})
export class DialogStartVideoComponent {
  atWelcome = true;

  constructor(
    public _session: SessionService,
    private dialogRef: MatDialogRef<DialogStartVideoComponent>
  ) {}

  changeLanguageVersion(locale: string) {
    this._session.setLocale(locale);
  }

  startModule() {
    this.dialogRef.close(true);
  }
} 